// Legacy BillingGroup serialization includes non camelcase properties
/* eslint-disable camelcase */
import Immutable from 'immutable'
import { createSelector } from 'reselect'

import createPaymentToken, { filterToken } from '../../records/PaymentToken'
import { constants as clientConstants } from './client'
import * as signupConstants from './signup/constants'

// ------------------------------------
// Constants
// ------------------------------------
export const DISCOVER_TOKEN = 'inf/paymentToken/DISCOVER_TOKEN'

// ------------------------------------
// Actions
// ------------------------------------
export const discoverToken = token => ({
  payload: { token },
  type: DISCOVER_TOKEN,
})

// ------------------------------------
// Selectors
// ------------------------------------
export const makeSelectPaymentToken = () => createSelector(
  state => state.paymentToken.get('tokens'),
  (state, { uuid }) => uuid,
  (tokens, uuid) => tokens.find(search => search.uuid === uuid),
)

export const selectPaymentTokensForClient = createSelector(
  state => state.get('tokens'),
  (state, filter) => filter,
  (tokens, filter) => tokens
    .filter(token => filterToken(token, filter))
    .sortBy(token => token.getIn(['card', 'number'])),
)

export const selectors = {
  selectPaymentTokensForClient,
}

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = Immutable.fromJS({
  tokens: Immutable.Set(),
})

function buildTokensFromClientResponse(oldTokens, clients) {
  const tokens = clients.reduce(
    (newTokens, { payment_tokens = [] }) => newTokens.union(payment_tokens),
    Immutable.Set(),
  )

  return tokens.reduce((newTokens, token) => {
    const newToken = createPaymentToken(token)

    return replaceToken(newTokens, newToken)
  }, oldTokens)
}

function buildTokensFromSignupResponse(oldTokens, signups) {
  const tokens = signups
    .filter(signup => signup.token)
    .map(signup => signup.token)

  return tokens.reduce((newTokens, token) => {
    const newToken = createPaymentToken(token)

    return replaceToken(newTokens, newToken)
  }, oldTokens)
}

function replaceToken(tokens, token) {
  return tokens
    .filter(search => search.get('uuid') !== token.get('uuid'))
    .add(token)
}

export default function reducer(state = initialState, action) {
  const { payload } = action

  switch (action.type) {
    case DISCOVER_TOKEN:
      return state.set('tokens', replaceToken(state.get('tokens'), createPaymentToken(payload.token)))

    case clientConstants.RECEIVE_CLIENTS:
      return state.set('tokens', buildTokensFromClientResponse(state.get('tokens'), payload.clients))

    case signupConstants.RECEIVE_SIGNUPS:
      return state.set('tokens', buildTokensFromSignupResponse(state.get('tokens'), payload.signups))

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/modules/paymentToken.js